const TEXT_INPUT_TYPES_ENUM = {
  TEXT: 'TEXT',
  DATE: 'DATE',
  PHONE: 'PHONE',
};

export default TEXT_INPUT_TYPES_ENUM;
